import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { R1FactType } from '@/api/rest/resources/types/fact';
import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import { SMPrecipitation } from '@/components/Charts/SMPrecipitation';
import { GraphFact } from '@/components/Charts/types';
import { GraphTileProps } from '@/components/IndicatorCard/GraphTile';
import { useOrganizationIndicatorGraphFact } from '@/pages/shared/hooks/useOrganizationFact';

import { NoData } from '../../../../components/NoData';

export const SMPrecipitationCardGraphTile = (props?: GraphTileProps | null) => {
  const { t } = useTranslation();

  const plotGroupId = props?.plotGroupId ?? null;
  const historicWaterAndSoilMoistureFact = R1FactType.r1_historic_water_and_soil_moisture_graph;

  const { [historicWaterAndSoilMoistureFact]: historicWaterAndSoilMoisture } = useOrganizationIndicatorGraphFact<
    GraphFact[]
  >(historicWaterAndSoilMoistureFact, null, undefined, plotGroupId);
  const whcData = historicWaterAndSoilMoisture?.value;

  const noChartData = !whcData?.length;

  if (noChartData) {
    return <NoData />;
  }

  const chartData = [...whcData];

  return (
    <Stack center data-testid='precipitation-historic-graph-tile'>
      <Stack spacing={2.5} className='w-full items-center justify-center px-1 py-6 lg:items-start lg:p-6 lg:pl-1'>
        <ChartHeading
          heading={t('shared.ncaDetail.details.water.labels.historicalGraphHeadlinePrecipitation')}
          popover={{
            title: t('shared.ncaDetail.details.water.explainers.historicalDataPrecipitation.title'),
            body: t('shared.ncaDetail.details.water.explainers.historicalDataPrecipitation.body'),
          }}
          className='w-full px-6 sm:px-0'
        />
        <SMPrecipitation data={chartData} className='relative' data-testid='precipitation-historical-chart' />
      </Stack>
    </Stack>
  );
};
